function PortalIcon({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#0a0a0a"
      strokeWidth="2.5"
    >
      <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M5 17h-2v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6-6h15m-6 0v-5" />
    </svg>
  );
}

export default function LoggedOutCard({ darkGray, onOpenLogin }) {
  return (
    <div className="card" style={{ padding: "48px", textAlign: "center", maxWidth: "520px", margin: "0 auto" }}>
      <div
        style={{
          width: "82px",
          height: "82px",
          background: "linear-gradient(135deg, #00d4aa 0%, #00a8cc 100%)",
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 24px",
          boxShadow: "0 8px 30px rgba(0, 212, 170, 0.3)",
        }}
      >
        <PortalIcon size={40} />
      </div>
      <h2
        style={{
          margin: "0 0 8px",
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "34px",
          fontWeight: "700",
        }}
      >
        <span className="glow">Kjøretøyportal</span>
      </h2>
      <p style={{ margin: "0 0 28px", color: darkGray }}>
        Logg inn med din e-postadresse for å se kjøretøydata.
      </p>
      <button className="btn-p" onClick={onOpenLogin} style={{ minWidth: "220px" }}>
        Åpne innlogging
      </button>
    </div>
  );
}
